/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Signup Button Mobile.
 */

import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

export const SignupButtonMobile = () => {
  const { loginWithRedirect } = useAuth0();

  const handleSignUp = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/dashboard",
      },
    });
  };

  return (
    <button className="button__sign-up-mobile" onClick={handleSignUp}>
      Sign Up
    </button>
  );
};
